import { View, Text } from "react-native";
import React from "react";

const SalePoint = () => {
  return (
    <View>
      <Text>SalePoint</Text>
    </View>
  );
};

export default SalePoint;
